import styled from 'styled-components';

import { IconSuccess, spaceMixin, token } from '@zillow/constellation';

export const StyledSuccessIcon = styled(IconSuccess)`
  && {
    color: ${token('colors.green400')};
    margin: 0 auto ${spaceMixin('xs')};
    display: block;

    height: 100px;
    width: 100px;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
